import React, { useEffect, useState } from "react";

import { useSelector, useDispatch } from "react-redux";

import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import Button from "@material-ui/core/Button";

import styles from "../../../styles/management.module.css";
import reducer, { usersActions } from "../../store";
import { useNavigate } from "react-router";
import { AutoSizer, Column, Table } from "react-virtualized";
import { FcSearch } from "react-icons/fc";
import Spinner from "../../spinner";
import Conf from "../../../conf";

const Users = () => {
    const history = useNavigate();
    const Dispatch = useDispatch();
    const [wait, set_wait] = useState(false);

    const [search, set_search] = useState("");
    const [users, set_users] = useState(Object.values(reducer.getState().users.items));
    const users_ = useSelector((state) => state.users.items);

    useEffect(() => {
        set_wait(true);
        fetch(`${Conf.server_address}/users?page=1&start=0&limit=25`, {
            method: "GET",
            headers: { "Content-Type": "application/json", accept: "application/json" },
            credentials: "include",
            cache: "no-cache",
        })
            .then((response) => {
                return response.json();
            })
            .then((response) => {
                Dispatch(usersActions.refresh(response));
                set_wait(false);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (search !== "")
            set_users(Object.values(users_).filter((x) => (x.name && x.name.includes(search)) || (x.email && x.email.includes(search)) || (x.phone && x.phone.includes(search))));
        else {
            set_users(Object.values(users_));
        }
    }, [search, users_]);

    return (
        <div className={styles.main}>
            <div className={styles.header}>
                <div className={styles.headerRight}>کاربران</div>
                <div className={styles.headerLeft} onClick={() => history("/map")}>
                    <KeyboardArrowLeftIcon className={styles.exitIcon} />
                    بازگشت
                </div>
            </div>
            <div className={styles.body}>
                <div className={styles.bodyTop}>
                    <div className={styles.bodyTopText}>تعداد کل کاربر ها :{users.length}</div>
                    <div className={styles.search_holder}>
                        <Button className={styles.add} variant="contained" component="label" onClick={() => history("/management/users/edit/new")}>
                            افزودن کاربر
                        </Button>
                        <span className={styles.GlobalFilterHolder}>
                            <input className={styles.GlobalFilter} value={search} onChange={(e) => set_search(e.target.value)} />

                            <FcSearch size={20} />
                        </span>
                    </div>
                </div>
                <div className={styles.contents}>
                    <Spinner wait={wait} center={true} color={"#263c99"}>
                        <div style={{ width: "100%", height: "100%", minWidth: 350 }}>
                            <AutoSizer>
                                {({ height, width }) => (
                                    <Table
                                        rowClassName={({ index: i }) => (i % 2 === 0 ? "table_ch_env" : "")}
                                        rowCount={users.length}
                                        rowGetter={({ index }) => users[index]}
                                        width={width}
                                        height={height}
                                        headerHeight={20}
                                        rowHeight={50}
                                        onRowClick={({ rowData }) => history(`/management/users/edit/${rowData.id}`)}
                                    >
                                        <Column dataKey={"0"} flexGrow={1} width={30} label="نام" height={50} cellRenderer={({ rowIndex, rowData }) => rowData.name} />
                                        <Column dataKey={"0"} flexGrow={1} width={30} label="نام کابری" height={50} cellRenderer={({ rowIndex, rowData }) => rowData.email} />
                                        <Column
                                            dataKey={"0"}
                                            flexGrow={1}
                                            width={30}
                                            label="تلفن"
                                            height={50}
                                            cellRenderer={({ rowIndex, rowData }) => (rowData.phone === "" ? "----" : rowData.phone)}
                                        />
                                    </Table>
                                )}
                            </AutoSizer>
                        </div>
                    </Spinner>
                </div>
            </div>
        </div>
    );
};

export default Users;
